import AbstractAnalyticProvider from 'coreClasses/analytics/providers/AbstractAnalyticProvider';
import {IAnalyticsProvidersConfiguration} from 'coreClasses/analytics/IAnalytics';
import {IGoogleTagManagerConfiguration} from 'coreClasses/analytics/providers/gtm/IGoogleTagManager';

import ManagerRepository from 'brandClasses/ManagerRepository';

import GoogleTagManagerAnalyticsProvider from './gtm/GoogleTagManagerAnalyticsProvider';

/**
 * Represents AnalyticsProvidersFactory
 */
class AnalyticsProvidersFactory {
	private static providers: {[key: string]: AbstractAnalyticProvider} = {};

	/**
	 * Creates analytics provider
	 * @param {string} providerName - provider name
	 * @returns {AbstractAnalyticProvider | undefined} - analytics provider
	 */
	public static create(
		providerName: string,
		managerRepository?: ManagerRepository,
		providersConfiguration?: IAnalyticsProvidersConfiguration
	): AbstractAnalyticProvider | undefined {
		if (!this.providers[providerName]) {
			let provider: AbstractAnalyticProvider;
			let googleProviderConfiguration;

			switch (providerName) {
				case 'GTM':
					googleProviderConfiguration = providersConfiguration[providerName] as IGoogleTagManagerConfiguration;
					provider = new GoogleTagManagerAnalyticsProvider(managerRepository, googleProviderConfiguration);

					break;
				default:
					break;
			}

			if (provider) {
				this.providers[providerName] = provider;
			}
		}

		return this.providers[providerName];
	}
}

export default AnalyticsProvidersFactory;
